import * as React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import * as d from "../../../reducers/domainReducer";
import { withTranslation } from 'react-i18next';
import { Grid, Typography, LinkText } from "../../ecosystem";
class Footer extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { bundle, isProxyUser, currentPharmacyUser, applicationVersion, technicalHelpDeskNumber, technicalHelpDeskHours, showAssistanceLink, fixBottom, currentYear } = this.props;
        let isClientSide = typeof window !== 'undefined';
        let showFooterLinks = bundle === "mybswhealth" || (bundle === "pharmacy" && !currentPharmacyUser);
        return (
            <Grid className={`footer-container footer-loggedin ${fixBottom}`}>
                {showAssistanceLink &&
                    <div className="row">
                        <div className="col-12 maxWidth-content footer__call">
                            Call the MyBSWHealth technical help desk {technicalHelpDeskHours} at <a href={"tel:" + technicalHelpDeskNumber} className="phone-link">{technicalHelpDeskNumber}</a>.
                        </div>
                    </div>
                }
                <div className="row footer__main">
                    <div className="col-12 maxWidth-content">
                        <div className="row">
                            {isClientSide &&
                                <div className="col-12 col-md-7 footer__links">
                                    {showFooterLinks &&
                                        <React.Fragment>
                                            <div className="footer-display">
                                                <LinkText typographyType="meta-01" decorator="none" underline="hover" to={{ pathname: "/terms" }}>
                                                    <b>Terms of Use</b>
                                                </LinkText>
                                                <LinkText typographyType="meta-01" decorator="none" underline="hover" to={{ pathname: "/privacy" }}>
                                                    <b>Digital Privacy Policy</b>
                                                </LinkText>
                                            </div>
                                            <div className="footer-display">
                                                <LinkText typographyType="meta-01" decorator="none" underline="hover" to={{ pathname: "/disclosures" }}>
                                                    <b>Disclosure Statements</b>
                                                </LinkText>
                                                <LinkText typographyType="meta-01" decorator="none" underline="hover" to={{ pathname: "/customerservice" }}>
                                                    <b>Customer Service</b>
                                                </LinkText>
                                            </div>
                                        </React.Fragment>
                                    }
                                </div>
                            }
                            <div className="col-12 col-md-5 footer__copyright">
                                <div className="copyright">
                                    <Typography type="meta-01">
                                        © {currentYear} All Rights Reserved
                                    </Typography>
                                </div>
                                <div className="mychart-copyright">
                                    <Typography type="meta-01">
                                        Version: {applicationVersion}
                                    </Typography>
                                    {window.serverData.data.enableI18N_LanguageSelection && (
                                        <div className="footer__language">
                                            <LinkText typographyType="meta-01" decorator="none" underline="hover"
                                                onClick={() => {
                                                this.props.i18n.changeLanguage('en');
                                                window.prevLanguage = 'en';
                                                }}>en</LinkText> | <LinkText
                                                    typographyType="meta-01" decorator="none" underline="hover"
                                                    onClick={() => {
                                                    this.props.i18n.changeLanguage('es');
                                                    window.prevLanguage = 'es';
                                                }}>es</LinkText>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Grid>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        technicalHelpDeskNumber: state.session.serverData.technicalHelpDeskNumber,
        technicalHelpDeskHours: state.session.serverData.technicalHelpDeskHours,
        //thrive: state.header.thrive, 
        bundle: state.session.serverData ? state.session.serverData.bundle : "mybswhealth",  // we'll default with rendering for mybswhealth
        isProxyUser: state.domain.ip,
        currentYear: state.session.serverData && state.session.serverData.currentYear ? state.session.serverData.currentYear : "2022",
        currentPharmacyUser: d.hydratePharmacyUser(state.domain.cpu),
        applicationVersion: state.session.serverData ? state.session.serverData.applicationVersion : "1.0.0.0",  // we'll default with rendering for mybswhealth
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Footer));